import {
  ListingsSearchCategory,
  getMainListingsSearchCategory,
} from '@kamernet/core/Routing/routes/ListingsSearch';

import { AnalyticsPageName } from '../types';

export function getListingAnalyticsPageName(
  searchCategories: ListingsSearchCategory[] | null,
): AnalyticsPageName {
  const mainSearchCategory = getMainListingsSearchCategory(searchCategories);

  switch (mainSearchCategory) {
    case ListingsSearchCategory.Room:
      return AnalyticsPageName.SearchRoom;
    case ListingsSearchCategory.Apartment:
      return AnalyticsPageName.SearchApartment;
    case ListingsSearchCategory.Antisquat:
      return AnalyticsPageName.SearchAntisquat;
    default:
      return AnalyticsPageName.SearchLivingPlace;
  }
}
